import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
export default {
  data: function data() {
    return {
      imgSrc: [{
        normal: require('../assets/images/Find selected_1.png'),
        avtive: require('../assets/images/Find selected.png'),
        isActive: true,
        path: '/social/club'
      },
      // { normal: require('../assets/images/Map.png'), avtive: require('../assets/images/Map selected.png'), path: '/map', isActive: false },
      // { normal: require('../assets/images/MG.png'), avtive: require('../assets/images/MG selected.png'), path: '/vehicleControl', isActive: false },
      {
        normal: require('../assets/images/Message.png'),
        avtive: require('../assets/images/Message selected.png'),
        path: '/message',
        isActive: false
      }, {
        normal: require('../assets/images/Me.png'),
        avtive: require('../assets/images/Me selected.png'),
        path: '/me',
        isActive: false
      }]
    };
  },
  created: function created() {
    var index = localStorage.getItem('bottomBarIndex') || 0;
    localStorage.setItem('bottomBarIndex', index);
    this.imgSrc.forEach(function (itm, idx) {
      itm.isActive = false;
    });
    this.imgSrc[index].isActive = true;
  },
  methods: {
    toPage: function toPage(path, index) {
      if (index !== 0) {
        localStorage.removeItem('activeName');
      }
      localStorage.setItem('bottomBarIndex', index);
      this.imgSrc.forEach(function (itm, idx) {
        itm.isActive = false;
      });
      this.imgSrc[index].isActive = true;
      if (this.$router.history.current.path !== path) {
        this.$router.replace({
          path: path
        });
      }
    }
  }
};